import classnames from "classnames";
import React from "react";
import { Countdown as CountdownComponent } from "src/components";

import { Slice } from "../components";
import { ISliceCountdown } from "../types";

export const Countdown = ({
  slice_type,
  primary,
  items,
}: ISliceCountdown): JSX.Element | null => {
  const { class_name: className } = primary;

  return (
    <Slice className={classnames("slice-countdown", className)} noGutter>
      <CountdownComponent data={primary} />
    </Slice>
  );
};
